import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BlogEntryDTO } from '../DTO/BlogEntryDTO';
import { BlogItemSkeleton } from './Skeleton';
import { formatDate } from '../lib/format';

interface ProjectBlogListProps {
    projectId: number;
}

export default function ProjectBlogList({ projectId }: ProjectBlogListProps) {
    const [posts, setPosts]     = useState<BlogEntryDTO[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError]     = useState(false);

    useEffect(() => {
        axios.get<BlogEntryDTO[]>(`/api/blog/project/${projectId}`)
            .then(res => setPosts(res.data))
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, [projectId]);

    if (loading) return <BlogItemSkeleton />;
    if (error)   return <p className="text-muted m-0">Related posts could not be loaded.</p>;
    if (!posts.length) return null;

    return (
        <section>
            <h2 className="text-2xl mb-5">Posts about this project</h2>
            <ul className="list-none p-0 m-0 flex flex-col gap-5">
                {posts.map(post => (
                    <li key={post.id}>
                        <time dateTime={post.publishDate} className="label block">
                            {formatDate(post.publishDate, 'short')}
                        </time>
                        <Link to={`/blog/${post.slug}`} className="font-display text-xl font-semibold text-ink hover:text-loden">
                            {post.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
}
